import * as React from 'react'
import { HeaderContainer } from '@user/components/DetailPages/HeaderContainer'
import { IOpportunityDetail } from '@user/store/opportunity/typings'
import { OPPORTUNITY_STATUSES } from '../../OpportunityCard/typings'
import { SOLD_SERVICE_STATUS } from '@sales-center/common'
import { OpportunityParentHeader } from '@user/features/EntityDetails/components'
import { useTheme } from '@mui/material/styles'

interface Props {
  detail: IOpportunityDetail
  status: OPPORTUNITY_STATUSES
  canUpdate: boolean
  canDelete: boolean
  soldServiceStatus: SOLD_SERVICE_STATUS
}

export const OpportunityActionsHeader: React.FC<Props> = (props) => {
  const { detail, status, canUpdate, canDelete, soldServiceStatus } = props
  const theme = useTheme()
  return (
    <HeaderContainer color={theme.palette.common.white} paddingY="8px">
      <OpportunityParentHeader
        attachmentCount={detail.attachmentCount}
        closedDate={detail.closedDate}
        closeWinDisabled={detail.closeWinDisabled}
        closeWinErrors={detail.closeWinErrors}
        detailPage
        expectedClosingDate={detail.expectedClosingDate}
        locationId={detail.externalLocationId}
        nextActionDate={detail.nextActionDate}
        opportunityId={detail.id}
        salesFunnelId={detail.salesFunnelId}
        salesFunnelStageId={detail.salesFunnelStageId}
        oppStatus={status}
        assignee={detail.assignee}
        branch={detail.branch}
        branchId={detail.branchId}
        salesTeamId={detail.salesTeamId}
        canUpdate={canUpdate}
        canDelete={canDelete}
        soldServiceStatus={soldServiceStatus}
      />
    </HeaderContainer>
  )
}

OpportunityActionsHeader.displayName = 'OpportunityActionsHeader'
